<template>
  <div
    :class="$style.base"
    v-test="'two-factor-verification'"
  >
    <Flex :direction="'column'">
      <BaseHeading
        size="xl"
        center
      >
        {{ $t('two_factor.header') }}
      </BaseHeading>
      <EnterToken
        :isLoading="isLoading"
        :tokenError="tokenError"
        :description="parseDescription"
        baseName="two_factor"
        @sendCode="verify"
      />
      <SendSMS
        v-if="isSMS"
        :email="credentials.email"
        :password="credentials.password"
        @smsSent="setMaskedNumber"
      />
    </Flex>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import axios from '@/axios';
import config from '@/config';
import {
  NativeAppMessage,
  sendNativeAppMessage,
} from '@/helpers/native-app-bridge';
import { redirectRoute } from '@/router/helpers';
import { useSessionStore } from '@/stores/session';
import { useUserStore } from '@/stores/user';
import { credentials } from '../credentials';
import EnterToken from '../verification/EnterToken.vue';
import SendSMS from './SendSMS.vue';

export default defineComponent({
  name: 'TwoFactorAuthentication',
  components: {
    EnterToken,
    SendSMS,
  },
  setup() {
    const { hasFeatureFlag } = useUserStore();
    return {
      credentials,
      hasFeatureFlag,
    };
  },
  data() {
    return {
      isLoading: false,
      tokenError: false,
      maskedNumber: '',
    };
  },
  computed: {
    isSMS() {
      return this.credentials.authenticator_mode === 'sms';
    },
    parseDescription() {
      if (this.isSMS) {
        return this.$t('two_factor.enter_code_description.sms', {
          mobile_number: this.maskedNumber,
        });
      } else {
        return this.$t('two_factor.enter_code_description.authenticator_app', {
          brandName:
            config.isTreatwellDomain || this.hasFeatureFlag('treatwell-brand')
              ? 'Treatwell Expert'
              : 'Salonized',
        });
      }
    },
  },
  methods: {
    setMaskedNumber(masked_phone) {
      this.maskedNumber = masked_phone;
    },
    verify(token) {
      this.tokenError = false;
      this.isLoading = true;

      axios
        .post('/sessions', {
          user: {
            email: this.credentials.email,
            password: this.credentials.password,
            two_factor_code: token,
          },
        })
        .then(({ data }) => {
          if (data.error) {
            this.tokenError = true;
            this.isLoading = false;
          } else {
            sendNativeAppMessage({
              message: NativeAppMessage.UserLogin,
            });
            const { fetchAllData } = useSessionStore();
            fetchAllData().then(() => {
              this.$router.push(redirectRoute({ query: this.$route.query }));
            });
          }
        })
        .catch(() => {
          this.tokenError = true;
          this.isLoading = false;
        });
    },
  },
  unmounted() {
    this.credentials.email = '';
    this.credentials.password = '';
    this.credentials.authenticator_mode = '';
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
}
</style>
